// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"6b619132","426":"f88d3451","651":"862e8aa2"}[chunkId] + ".chunk.js";
};